module.exports = __webpack_public_path__ + "img/05.8b8bf82f.png";